import { useFormState, useWatch, type Control } from 'react-hook-form';

import type { ConfirmArrivalFormValues } from './types';

/**
 * One line's slice of the form — its values and its errors. Every cell of the
 * row subscribes on its own, so typing re-renders that row's cells alone, never
 * the whole table.
 */
export const useConfirmArrivalLine = (control: Control<ConfirmArrivalFormValues>, index: number) => {
  const name = `lines.${index}` as const;
  const values = useWatch({ control, name });
  const { errors } = useFormState({ control, name });
  return { name, values, errors: errors.lines?.[index] };
};
